
const Swal = require('sweetalert2')

export default {
  methods: {
    showError(msg) {

      console.log(msg)

      var error = msg

      if (msg) {
        if (msg.response) {

          if (msg.response.status == 422) {

            error = JSON.stringify(msg.response.data).replace(/["']/g, "")
            
          } else if (msg.response.data) {
            if(msg.response.data.length > 100) {
              error = msg.response.statusText
            } else {
              error = msg.response.data
            }
          }
        } else if (msg.message) {
          error = msg.message
        }
      }
   
      console.log(error)

      /*Swal.fire({
        toast: true,
        position: 'top-end',
        type: 'error',
        showConfirmButton: false,
        timer: 5000,
        title: error,
        width: 300,
        background: "#ffdadaeb"
      })*/

      this.$toasted.show(error, {
          theme: 'outline',
          position: "top-right", 
          icon: 'fa-exclamation-triangle', 
          type: 'error', 
          duration: 3000, //3000
          iconPack: "fontawesome"
        }
      );

      

      /*this.$toasted.show(error, { 
        theme: "toasted-primary", 
        position: "top-center", 
        type: 'error',
        duration : 2500
      });*/

      //Vue.$toast.open({ message: "Ups!: " + error, type:"error", position:"bottom-right", dismissible: true });
      //--this.$Progress.fail()
    },
    showOK(msg) {
      
      //--this.$Progress.finish()

      if (msg != "") {
        console.log(msg)

        /*Swal.fire({
          position: 'top-end',
          type: 'success',
          showConfirmButton: false,
          timer: 1500,
          title: "Excelente!: " + msg,
          width: 300
        })*/

        /*Swal.fire({
          toast: true,
          position: 'top-end',
          type: 'success',
          showConfirmButton: false,
          timer: 3000,
          title: msg,
          background: "#d4ffd6eb"
        })*/

        this.$toasted.show(msg, { 
          theme: "outline", 
          position: "top-right", 
          icon: 'fa-check-square-o', 
          type: 'success',
          duration : 3000, //3000
          iconPack: "fontawesome"
        });
        
        //Vue.$toast.open({message: "Excelente!: " + msg, type:"success", position:"bottom-right", dismissible: true });
      }
      
    },
    showQueue() {
      const ipAPI = 'https://api.ipify.org?format=json'

      Swal.queue([{
        title: 'Your public IP',
        confirmButtonText: 'Show my public IP',
        text:
          'Your public IP will be received ' +
          'via AJAX request',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return fetch(ipAPI)
            .then(response => response.json())
            .then(data => Swal.insertQueueStep(data.ip))
            .catch(() => {
              Swal.insertQueueStep({
                type: 'error',
                title: 'Unable to get your public IP'
              })
            })
        }
      }])
    },
    showMixin () {
            
      Swal.mixin({
        input: 'text',
        confirmButtonText: 'Next &rarr;',
        showCancelButton: true,
        progressSteps: ['1', '2', '3']
      }).queue([
        {
          title: 'Question 1',
          text: 'Chaining swal2 modals is easy'
        },
        'Question 2',
        'Question 3'
      ]).then((result) => {
        if (result.value) {
          Swal.fire({
            title: 'All done!',
            html:
              'Your answers: <pre><code>' +
                JSON.stringify(result.value) +
              '</code></pre>',
            confirmButtonText: 'Lovely!'
          })
        }
      })
    },
    showFire () {
      let timerInterval
      Swal.fire({
        title: 'Auto close alert!',
        html: 'I will close in <strong></strong> seconds.',
        timer: 2000,
        onBeforeOpen: () => {
          Swal.showLoading()
          timerInterval = setInterval(() => {
            Swal.getContent().querySelector('strong')
              .textContent = Swal.getTimerLeft()
          }, 100)
        },
        onClose: () => {
          clearInterval(timerInterval)
        }
      }).then((result) => {
        if (
          // Read more about handling dismissals
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log('I was closed by the timer')
        }
      })
    },
    updateProgress() {
      //--this.$Progress.start()
    }
  }
};